import React from 'react'

import RenderDOM from '../RenderDOM'

const RowComponent = ({
  content,
  mode,
  onChangeFormBuilderState,
  formValues,
  onPatchFormValues,
  onClickSubmitForm,
  createSubmittedFormMedia,
  currentPage,
  dom,
  findObjectAndPatch,
  isInputDisabled,
  togglePageSelection,
  togglePageSelectable,
  duplicatePage,
  currentLanguage
}) => {
  return (
    <div className="row w-100 m-auto">
      {
        content.children && content.children.map(( item, index ) => {
          return <RenderDOM                       
            content={ {...item, rowComponentIndex: index } }
            onChangeFormBuilderState={ onChangeFormBuilderState }
            mode={ mode }
            formValues={ formValues }
            onPatchFormValues={ onPatchFormValues }
            onClickSubmitForm={ onClickSubmitForm }
            createSubmittedFormMedia={ createSubmittedFormMedia }
            currentPage={ currentPage }
            dom={ dom }
            findObjectAndPatch={ findObjectAndPatch }
            data={ {} }
            isInputDisabled={ isInputDisabled }
            togglePageSelection={ togglePageSelection }
            togglePageSelectable={ togglePageSelectable }
            duplicatePage={ duplicatePage }
            currentLanguage={ currentLanguage }
            showPageRearrangement={ null }
          />
        })
      }
    </div>
  )
}

export default RowComponent